/* This file is autogenerated, see readme.md for instructions */
import InternetSvgIcon from '@bloomreach/banana-theme/icons/internet.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const InternetIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <InternetSvgIcon />
    </Icon>
  );
});

InternetIcon.displayName = 'InternetIcon';

export default InternetIcon;
